import React from 'react';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  RocketOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import connectionCheckImg from '../../../assets/connection-check.png';
import chatgptAddAppImg from '../../../assets/chatgpt-add-cirra-app.png';
import chatgptMessageBarImg from '../../../assets/chatgpt-message-bar-app.png';

export const CompletionStep: React.FC = () => {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <CheckCircleOutlined
          style={{
            fontSize: 48,
            color: '#52c41a',
            marginBottom: 16,
          }}
        />
        <h2 style={{ color: '#52c41a', margin: 0 }}>Setup Complete!</h2>
      </div>
      <div>
        <p>
          To verify that everything is set up correctly, you can ask your AI
          client:
        </p>
        <ul style={{ margin: '12px 0', paddingLeft: 20 }}>
          <li>
            &quot;What Salesforce org am I connected to with Cirra AI?&quot;
          </li>
          <li>&quot;Initialize Cirra AI&quot;</li>
        </ul>
        <p>
          <ExclamationCircleOutlined style={{ color: '#fa8c16' }} /> ChatGPT
          users: see the important note{' '}
          <a
            href="#chatgpt-note"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById('chatgpt-note')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            below
          </a>
        </p>
        <p>
          You should see a call to initialize the Cirra AI MCP server, and a
          confirmation of your user name and the Salesforce org you connected
          earlier:
        </p>
        <img
          src={connectionCheckImg}
          alt="Connection check example"
          className="walkthrough-screenshot"
          style={{
            width: '80%',
            display: 'block',
            margin: '24px auto',
          }}
        />
      </div>
      <div className="walkthrough-highlight">
        <div className="walkthrough-highlight-title">
          <RocketOutlined /> What&apos;s Next?
        </div>
        <p>
          Your Salesforce org is connected and ready to go! You can now use our
          MCP Server to streamline your Salesforce admin tasks.
        </p>
        <p>Try asking your AI assistant:</p>
        <ul style={{ margin: '12px 0', paddingLeft: 20 }}>
          <li>&quot;What custom objects exist in my Salesforce org?&quot;</li>
          <li>&quot;Show me recent opportunities in my pipeline&quot;</li>
          <li>&quot;Create a flow to segment accounts by revenue&quot;</li>
          <li>&quot;Help me create a validation rule for leads&quot;</li>
        </ul>
        <p>Or simply: What can I do with Cirra AI?</p>
        <p>
          <ThunderboltOutlined style={{ color: '#fa8c16' }} /> To get even more
          out of Cirra AI, install skills from the{' '}
          <a
            href="https://skills.cirra.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cirra AI Skills Library
          </a>{' '}
          to supercharge your AI client with enhanced Salesforce admin
          capabilities.
        </p>
      </div>
      <hr />
      <div id="chatgpt-note" className="walkthrough-highlight">
        <div className="walkthrough-highlight-title">
          <p>
            <ExclamationCircleOutlined style={{ color: '#fa8c16' }} /> ChatGPT
            users:
          </p>
        </div>
        <p>
          In each new chat, click the <strong>+</strong> icon in the message and
          enable the <strong>Cirra AI</strong> app before sending your prompt.
        </p>
        <img
          src={chatgptAddAppImg}
          alt="Select the Cirra AI app from the menu"
          className="walkthrough-screenshot"
        />
        <img
          src={chatgptMessageBarImg}
          alt="Verify that the Cirra AI app appears in the ChatGPT message bar"
          className="walkthrough-screenshot"
        />
      </div>
    </div>
  );
};
